/**
 * Provides service functions for managing key guidelines, including
 * retrieving, creating, deleting, and updating guideline records and
 * their display order through backend APIs.
 */
import { api } from "@/api";


export async function getKeyGuidelines(): Promise<any> {
  const res = await api.keyGuidelines();
  return res;
}


export async function addKeyGuideline(
  title: string,
  url: string
) {
  return await api.addKeyGuideline({
    title,
    url,
  });
}

export async function deleteKeyGuideline(id: number) {
  return await api.deleteKeyGuideline(id);
}

export async function updateKeyGuidelineOrder(
  guidelines: any[]
) {
  return await api.updateKeyGuidelineOrder(
    guidelines
  );
}
